import { useApp } from '../../../../../context/App';
import { INews } from '../../../../../types/news';
import { parseDate } from "../../../../../utils/date";

interface Props {
	news: INews
}

export function SideTopNews({ news }: Props) {
	const { configDomainURL } = useApp()
	const domain = configDomainURL
	const link_montado = news.title
		.toLowerCase()
		.replaceAll(' ', '-')
		.replaceAll('/', '-')
		.replaceAll(new RegExp('[&/\\\\#,+()$~%.\'":*?<>{}]', 'g'), '')
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, "")

	const SideTopNews_img = 'https://api-portal.itajai.sc.gov.br/public/portaladm-pmitajai/noticias/foto/' + news.img

	return (
		<a
			href={`${domain}noticias/${news.newsId}/${link_montado}`}
			className="flex-1 w-full flex flex-col bg-surface-secondary dark:bg-surface-dark-secondary rounded-2xl overflow-hidden no-underline group shadow-md dark:shadow-premium-dark hover:shadow-xl transition-all duration-300 transform hover:scale-[1.02] border border-border-default dark:border-white/10"
		>
			{!!news.img && (
				<div className="w-full aspect-[2.6/1] overflow-hidden bg-surface-alt dark:bg-surface-dark">
					<img
						src={SideTopNews_img}
						className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110 dark:opacity-90"
						alt={news.title}
						loading="lazy"
					/>
				</div>
			)}

			<div className="p-3 flex flex-col justify-center gap-1 w-full">
				<span className="text-[10px] uppercase tracking-widest text-on-surface-subtle dark:text-on-surface-dark-muted font-medium">
					{parseDate(news.published)}
				</span>
				<h4 className="text-on-surface dark:text-on-surface-dark font-bold text-sm leading-snug line-clamp-2 transition-colors duration-200 group-hover:text-primary dark:group-hover:text-secondary">
					{news.title}
				</h4>
			</div>
		</a>
	)
}